import type { HttpClient } from '@shared/http/http-client';
import type { ILabRepository } from '@domain/data-contracts/lab-repository.interface';
import type { LabDetail, LabUpdateRequest } from '@domain/models/lab.interface';

interface LabDetailDto {
  readonly labId: number;
  readonly code: string;
  readonly name: string;
  readonly contactEmail: string | null;
  readonly contactPhone: string | null;
  readonly address: string | null;
  readonly city: string | null;
  readonly country: string | null;
  readonly serviceTier: number;
  readonly isActive: boolean;
}

function mapLabDetailDto(dto: LabDetailDto): LabDetail {
  return {
    labId: dto.labId,
    code: dto.code,
    name: dto.name,
    contactEmail: dto.contactEmail,
    contactPhone: dto.contactPhone,
    address: dto.address,
    city: dto.city,
    country: dto.country,
    serviceTier: dto.serviceTier,
    isActive: dto.isActive,
  };
}

const BASE = '/api/admin/labs';

export class LabRepository implements ILabRepository {
  public constructor(private readonly http: HttpClient) {}

  public async listAll(signal?: AbortSignal): Promise<readonly LabDetail[]> {
    const response = await this.http.get<readonly LabDetailDto[]>(BASE, { signal });
    return response.data.map(mapLabDetailDto);
  }

  public async getById(id: number, signal?: AbortSignal): Promise<LabDetail> {
    const response = await this.http.get<LabDetailDto>(`${BASE}/${id}`, { signal });
    return mapLabDetailDto(response.data);
  }

  public async update(id: number, req: LabUpdateRequest, signal?: AbortSignal): Promise<LabDetail> {
    const response = await this.http.put<LabDetailDto>(`${BASE}/${id}`, req, { signal });
    return mapLabDetailDto(response.data);
  }
}
